/**
 * Route for `link-tester`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LinkTesterPage } from "../features/link-tester/LinkTesterPage";

export const linkTesterRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/link-tester",
	component: LinkTesterPage,
});

export default linkTesterRoute;
